import { useState } from "react";

export type StudioTheme = "light" | "dark";
export const STUDIO_THEME_KEY = "stencil-studio:appearance";

function storedTheme(): StudioTheme | null {
  try {
    const value = localStorage.getItem(STUDIO_THEME_KEY);
    return value === "light" || value === "dark" ? value : null;
  } catch { return null; }
}

export function useStudioTheme() {
  const [preference, setPreference] = useState<StudioTheme | null>(storedTheme);
  // Match the public homepage on first entry; an artist's saved choice wins.
  const theme = preference ?? "dark";
  const toggleTheme = () => {
    const next = theme === "dark" ? "light" : "dark";
    setPreference(next);
    try { localStorage.setItem(STUDIO_THEME_KEY, next); } catch { /* Appearance still works when browser storage is unavailable. */ }
  };
  return { theme, toggleTheme };
}
